import { useEffect, useState } from 'react'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import client from 'api/client'
import { ArticleFlat, Permission } from 'types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface Props {
  withActiveReviews?: boolean
  permissions?: Permission[]
  skipProjects?: boolean
  items?: number
}

export const useRecentDocs = ({ withActiveReviews, permissions, skipProjects, items = 12 }: Props) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const [recentDocs, setRecentDocs] = useState<ArticleFlat[]>([])
  const [loading, setLoading] = useState(true)

  const stringifiedPermissions = permissions?.join(',')

  useEffect(() => {
    const getRecentFiles = async () => {
      const response = await client.getRecentDocs({
        workspaceId: currentWorkspaceId,
        items: items,
        withActiveReviews,
        permissions,
        skipProjects,
      })
      if (response.type === SUCCESS_RESPONSE_TYPE) {
        setRecentDocs(response.data.files)
      }
      setLoading(false)
    }
    getRecentFiles()
  }, [currentWorkspaceId, withActiveReviews, stringifiedPermissions, skipProjects]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    recentDocs: recentDocs,
    loading: loading,
  }
}
